import type { ExperienceSpec } from "@luxidar/experience-schema";

export function experienceSummary(spec: ExperienceSpec): string[] {
  const object = spec.scene.objects[0];
  const items: string[] = [];
  if (object) {
    const distance = Math.abs(object.transform.position[2]);
    items.push(`${Number(distance.toFixed(2))} m ahead`);
  }
  items.push(spec.camera.mode === "headTracked" ? "3DoF head tracking" : "Fixed viewpoint");
  if (spec.camera.mode === "headTracked" && spec.camera.tracking.recenterOnEnter) items.push("Recenter on entry");
  const rotation = object?.behaviors.find((behavior) => behavior.type === "autoRotate");
  if (rotation) items.push(`${rotation.speedDegPerSec}°/s ${rotation.axis.toUpperCase()}-axis rotation`);
  if (spec.audio.length) items.push("Entry audio on open");
  return items;
}
